export const DEFAULT_COURSES_COUNT = 9;
